// extracted by mini-css-extract-plugin
export default {"section-body":"SectionBody_section-body__3SmT-"};